/* ==========================================================================
   PanelAccommodationPackages > Config
   ========================================================================== */
const configuration = {
    selector: '[data-component="PanelAccommodationPackages"]',
    style: 'panel-accommodation-packages',
    helperStyles: {
        hidden: 'is-hidden',
        disabled: 'is-disabled'
    },
    config: {
        data: {
            maxRooms: 4,
            codeAdults: '30A',
            codeChildren: 'C'
        }
    },
    rooms: {
        type: 'rooms',
        selector: '[data-type="rooms"]'
    },
    room: {
        type: 'room',
        selector: '[data-type="room"]',
        id: 'room-1',
        defaultAgeAdults: 30,
        defaultAgeChildren: false,
        codeAdults: 'A',
        codeChildren: 'C',
        selectorAdults: (instance, id) =>
            `${instance.selector} ${configuration.room.selector}[data-id="${id}"] ` +
            `${configuration.adults.selector}`,
        selectorChildren: (instance, id) =>
            `${instance.selector} ${configuration.room.selector}[data-id="${id}"] ` +
            `${configuration.children.selector}`
    },
    roomTitle: {
        type: 'room-title',
        selector: '[data-type="room-title"]'
    },
    removeRoom: {
        type: 'room-remove',
        selector: '[data-type="room-remove"]'
    },
    adults: {
        selector: '[data-component="Counter"][data-type="counter-adults"]',
        config: {
            data: {
                type: 'counter-adults',
                min: '1',
                max: '6',
                value: '2'
            }
        }
    },
    children: {
        selector: '[data-component="Counter"][data-type="counter-children"]',
        config: {
            data: {
                type: 'counter-children',
                min: '0',
                max: '5',
                value: '0'
            }
        }
    },
    ages: {
        type: 'ages',
        selector: '[data-type="ages"]'
    },
    childrenAge: {
        type: 'children-age',
        selector: '[data-component="Select"][data-type="children-age"]',
        styles: ['select--with-border', 'panel-accommodation-packages__select'],
        min: 0,
        max: 17
    },
    discounts: {
        styles: {
            unique: 'panel-accommodation-packages__agroupation--discount',
            multiple: 'panel-accommodation-packages__agroupation--discounts'
        }
    },
    resident: {
        selector: '[data-component="Select"][data-type="resident"]',
        config: {
            styles: ['select--with-border', 'panel-accommodation-packages__select-discount'],
            data: {
                type: 'resident'
            }
        }
    },
    bonuses: {
        selector: '[data-component="Select"][data-type="bonuses"]',
        config: {
            styles: ['select--with-border', 'panel-accommodation-packages__select-discount'],
            data: {
                type: 'bonuses'
            }
        }
    },
    triggerAddRoom: [],
    /* eslint-disable no-useless-concat */
    getSelector: element => `${configuration.selector} ${configuration[element].selector}`,
    getSelectorId: element =>
        `${configuration.selector} ` + `${configuration[element].selector}[data-id="${configuration[element].id}"]`,
    getSelectorPrependedId: (element, id) =>
        `${configuration.selector} [data-id="${id}"]` + `${configuration[element].selector}`,
    getSelectorById: (instance, element, id) =>
        `${instance.selector} [data-id="${id}"] ` + `${configuration[element].selector}`
};

const config = () => configuration;

module.exports = config;
